import { fromBox } from './placementModel'

// Sends placements + background + only the non-empty text overrides. The
// backend fills the rest (text samples, image samples) itself. Placements go
// through fromBox so IMAGE fields are sent in the backend's center-anchored
// convention (the editor holds them top-left). templateScale/templatePosition/
// templateCrop/x/y are the (possibly unsaved) template layout, matching
// PreviewOverlayRequest, so a preview of in-progress layout edits matches Edit.
export function buildPreviewRequest({
  templateSvgUrl, placements, previewText = {}, targetMode = null,
  templateScale = null, templatePosition = null, templateCrop = null, x = null, y = null,
  homeBarColor = null, awayBarColor = null, barColor = null,
}) {
  const values = {}
  for (const [k, v] of Object.entries(previewText)) if (v) values[k] = v
  return {
    templateSvgUrl,
    placements: placements.map(fromBox),
    targetMode,
    values,
    templateScale,
    templatePosition,
    templateCrop,
    x,
    y,
    homeBarColor,
    awayBarColor,
    barColor,
  }
}
